import { motion, useAnimationControls } from "framer-motion";
import { useEffect, useState } from "react";

const trailingDots = [
  "hsl(170, 70%, 55%)",
  "hsl(200, 85%, 60%)",
  "hsl(320, 65%, 55%)",
  "hsl(40, 90%, 60%)",
];

const CELEBRATION_KEY = "jaik_logo_celebrate";

const JaikLogo = ({ className = "" }: { className?: string }) => {
  const [hovered, setHovered] = useState(false);
  const [celebrating, setCelebrating] = useState(false);
  const dotControls = useAnimationControls();

  // Listen for the intro animation finishing, play a one-time pop + expand/contract
  useEffect(() => {
    const trigger = async () => {
      setCelebrating(true);
      // pop the primary dot as it "lands"
      await dotControls.start({
        scale: [0.6, 1.6, 1],
        transition: { duration: 0.45, ease: [0.34, 1.56, 0.64, 1] },
      });
      // expand trailing dots, hold, then contract
      setHovered(true);
      await new Promise((r) => setTimeout(r, 900));
      setHovered(false);
      setCelebrating(false);
    };

    if (sessionStorage.getItem(CELEBRATION_KEY)) {
      sessionStorage.removeItem(CELEBRATION_KEY);
      trigger();
    }

    const onEvent = () => trigger();
    window.addEventListener("jaik:logo-celebrate", onEvent);
    return () => window.removeEventListener("jaik:logo-celebrate", onEvent);
  }, [dotControls]);

  return (
    <span
      className={`relative inline-flex items-baseline cursor-pointer ${className}`}
      onMouseEnter={() => !celebrating && setHovered(true)}
      onMouseLeave={() => !celebrating && setHovered(false)}
    >
      <span>jaik</span>
      {/* Primary signal-orange dot, always visible, animates on celebration */}
      <motion.span
        className="inline-block rounded-full ml-[2px] mb-[3px]"
        style={{ backgroundColor: "hsl(var(--jaik-dot))", width: "0.24em", height: "0.24em" }}
        animate={dotControls}
      />
      {/* Trailing dots, expand on hover or celebration */}
      <span className="inline-flex items-end gap-[3px] ml-[3px] mb-[3px]">
        {trailingDots.map((color, i) => (
          <motion.span
            key={i}
            className="inline-block rounded-full"
            style={{ backgroundColor: color, height: "0.24em" }}
            animate={{
              opacity: hovered ? 1 : 0,
              scale: hovered ? 1 : 0,
              width: hovered ? "0.24em" : "0em",
              marginRight: hovered ? "0em" : "-0.15em",
            }}
            transition={{
              delay: hovered ? i * 0.06 : (trailingDots.length - 1 - i) * 0.04,
              duration: 0.25,
              ease: "easeOut",
            }}
          />
        ))}
      </span>
    </span>
  );
};

export default JaikLogo;
